module.exports = __webpack_public_path__ + "static/media/words_of_god.74cd5287.webp";